
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component({
  name: 'TabChange'
})
export default class extends Vue {
  @Prop({ default: '' }) orderStatics: any
  @Prop({ default: '' }) defaultActivity: any
  private activeIndex: number = 0

  @Watch('defaultActivity', { immediate: true })
  private onChange(val) {
    this.activeIndex = Number(val) || 0
  }

  get changedOrderList() {
    return [
      {
        label: '全部订单',
        value: 0
      },
      {
        label: '待核销',
        value: 2,
        num: this.orderStatics.toBeConfirmed
      },
      {
        label: '已完成',
        value: 5
      },
      {
        label: '已取消',
        value: 6
      }
    ]
  }

  private tabChange(activeIndex) {
    this.activeIndex = activeIndex
    this.$emit('tabChange', activeIndex)
  }
}
